import * as React from 'react';
import { View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import TripHistoryBreakdown from '@/components/trip-history';

export type TripBreakdownTabOption = 'summary' | 'tolls' | 'incidentals';

export default function TripHistoryBreakdownScreen() {
  const { theme } = useStyles();

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background_1 }}>
      <TripHistoryBreakdown />
    </View>
  );
}
